export default __webpack_public_path__ + "static/media/export_icon.f75474c7.svg";